import { call, put, all, fork, takeEvery, select } from 'redux-saga/effects'

import { showLoading, hideLoading } from 'react-redux-loading-bar'

import GovernoratesService from '../middlewares/governorates'

import {
  GET_GOVERNORATES,
  GET_GOVERNORATES_REQUEST,
  GET_GOVERNORATES_REQUEST_ERROR,
  GET_GOVERNORATES_REQUEST_PENDING,
  GET_GOVERNORATES_REQUEST_SUCCESS,
  PULL_GOVERNORATES_REQUEST,
} from '../types/governorates'

function* getGovernoratesWatcher() {
  yield takeEvery(GET_GOVERNORATES_REQUEST, getGovernoratesWorker)
}

function* pullGovernoratesWatcher() {
  yield takeEvery(PULL_GOVERNORATES_REQUEST, pullGovernoratesWorker)
}

function* getGovernoratesWorker({ payload: { page, size, search } }) {
  try {
    yield put(showLoading())
    yield put({ type: GET_GOVERNORATES_REQUEST_PENDING })
    const response = yield call(GovernoratesService.getGovernorates, page, size, search)
    const { result, total } = response.data.data
    yield put({
      type: GET_GOVERNORATES,
      payload: {
        items: result,
        pagination: {
          current: page,
          pageSize: size,
          total: total,
        },
      },
    })
    yield put({ type: GET_GOVERNORATES_REQUEST_SUCCESS })
    yield put(hideLoading())
  } catch (error) {
    yield put({
      type: GET_GOVERNORATES_REQUEST_ERROR,
      payload: error?.response?.data?.messages || [error.message],
    })
    yield put(hideLoading())
  }
}

function* pullGovernoratesWorker() {
  try {
    yield put(showLoading())
    yield put({ type: GET_GOVERNORATES_REQUEST_PENDING })
    yield call(GovernoratesService.pullGovernorates)
    const { current, pageSize } = yield select((state) => state.governorates.pagination)
    yield put({
      type: GET_GOVERNORATES_REQUEST,
      payload: {
        page: current,
        size: pageSize,
      },
    })
    yield put({ type: GET_GOVERNORATES_REQUEST_SUCCESS })
    yield put(hideLoading())
  } catch (error) {
    yield put({
      type: GET_GOVERNORATES_REQUEST_ERROR,
      payload: error?.response?.data?.messages || [error.message],
    })
    yield put(hideLoading())
  }
}

export default function* governorates() {
  yield all([fork(getGovernoratesWatcher), fork(pullGovernoratesWatcher)])
}

